import type { ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { useRegistroPublico } from '../hooks/use-registro-publico';

/** Texto y destino de las páginas públicas mientras el alta de empresas está cerrada. */
export const TEXTO_DEMO = 'Pide una demo';
export const DESTINO_DEMO = '/contact?asunto=demo-producto';

type RegistroCtaProps = Omit<LinkProps, 'to'> & { children: ReactNode };

/**
 * Botón de «registrarse» de las páginas públicas. Con el alta pública abierta, es el enlace
 * de siempre a `/register` (con su texto). Con el alta cerrada —lo normal—, dice «Pedí una
 * demo» y lleva a contacto con el asunto de demo preseleccionado. Mientras el servidor no
 * responde, muestra «Pide una demo»: ante la duda, no se ofrece registrarse.
 */
export function RegistroCta({ children, ...rest }: RegistroCtaProps) {
  const abierto = useRegistroPublico();

  if (abierto) {
    return (
      <Link to="/register" {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <Link to={DESTINO_DEMO} {...rest}>
      {TEXTO_DEMO}
    </Link>
  );
}

export default RegistroCta;
